// //  ----version 2---------
// import React, { useEffect, useState } from "react";
// import { BiSearch, BiExit, BiMenu } from "react-icons/bi";
// import { GrPieChart, GrGroup } from "react-icons/gr";
// import { CgProfile, CgScreen } from "react-icons/cg";
// import { MdReport, MdWork } from "react-icons/md";
// import Header from "../../component/Header";
// import { BsEnvelopeAtFill, BsMenuUp, BsPeople } from "react-icons/bs";
// import { FaMoneyBillTransfer } from "react-icons/fa6";
// import { Link } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import DashboardSummary from "../../component/DashboardComponents/DashboardSummary";
// import Profile from "../../component/DashboardComponents/Profile";
// import JobSeeker from "../../component/DashboardComponents/jobSeeker";
// import JobEmployer from "../../component/DashboardComponents/JobEmployer";
// import JobsInfo from "../../component/DashboardComponents/Jobs";
// import BenefitReguests from "../../component/DashboardComponents/BenefitReguests";
// import SalaryPayment from "../../component/DashboardComponents/SalaryPayment";
// import Report from "../../component/DashboardComponents/Report";
// import InterviewsReport from "../../component/DashboardComponents/Interview";
// import OtherCandiddates from "../../component/DashboardComponents/OtherCandiddates";
// import { setCandidateList } from "../../redux/candidateList/candidateListSlice";

// const getAllJobURL = `${process.env.REACT_APP_API_URL}job/allJob`;
// const getAllNotificationURL = `${process.env.REACT_APP_API_URL}notification/getAllNotification`;
// const getAllApplications = `${process.env.REACT_APP_API_URL}application/allApplication`;
// const getAllEmployer = `${process.env.REACT_APP_API_URL}jobrecruiter/allJobEmployer`;
// const getAllJobSeeker = `${process.env.REACT_APP_API_URL}jobSeeker/allJobSeeker`;
// const getAllInterview = `${process.env.REACT_APP_API_URL}interview/getAllInterview`;
// const getJobSeekerReport = `${process.env.REACT_APP_API_URL}employeeReport/getAllEmployeeReport`;
// const getEmployerReport = `${process.env.REACT_APP_API_URL}employerReport/getAllEmployerReport`;
// const getAllCandidates = `${process.env.REACT_APP_API_URL}otherCandidate/getAllCandidate`;

// const Dashboard = () => {
//   const [allJobs, setAllJobs] = useState([]);
//   const [allNotification, setAllNotification] = useState([]);
//   const [allApplication, setAllApplication] = useState([]);
//   const [allEmployers, setAllEmployers] = useState([]);
//   const [allJobSeeker, setAllJobSeeker] = useState([]);
//   const [selection, setSelection] = useState("home");
//   const [interviewData, setInterviewData] = useState([]);
//   const currentUser = useSelector((state) => state.user.currentUser);
//   const candidateList = useSelector(
//     (state) => state.candidateList.candidateList
//   );
//   const [jobSeekerReport, setJobSeekerReport] = useState([]);
//   const [jobEmployerReport, setJobEmployerReport] = useState([]);
//   const [allCandidates, setAllCandidates] = useState(null);

//   const dispatch = useDispatch();

//   useEffect(() => {
//     const getData = async () => {
//       const appData = await Promise.all(
//         [
//           getAllJobURL,
//           getAllNotificationURL,
//           getAllApplications,
//           getAllEmployer,
//           getAllJobSeeker,
//           getAllInterview,
//           getJobSeekerReport,
//           getEmployerReport,
//           getAllCandidates,
//         ].map(async (eachURL) => {
//           const data = await axios.get(eachURL);
//           return data.data;
//         })
//       );
//       setAllJobs(appData[0]);
//       setAllNotification(appData[1]);
//       setAllApplication(appData[2]);
//       setAllEmployers(appData[3]);
//       setAllJobSeeker(appData[4]);
//       setInterviewData(appData[5]);
//       setJobSeekerReport(appData[6]);
//       setJobEmployerReport(appData[7]);
//     };
//     getData();
//   }, []);

//   useEffect(() => {
//     const fetchAllCandidate = () => {
//       axios
//         .get(getAllCandidates)
//         .then((response) => {
//           dispatch(setCandidateList(response.data));
//           console.log("result", response.data);
//           setAllCandidates();
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     };

//     fetchAllCandidate();
//   }, []);

//   const renderView = () => {
//     switch (selection) {
//       case "profile":
//         return <Profile data={currentUser} />;
//       case "jobSeeker":
//         return <JobSeeker data={allJobSeeker} />;
//       case "jobEmployer":
//         return <JobEmployer data={allEmployers} />;
//       case "jobs":
//         return <JobsInfo data={allJobs} />;
//       case "benefits":
//         return <BenefitReguests data={[1, 2]} />;
//       case "salary":
//         return <SalaryPayment />;
//       case "otherCandidates":
//         return <OtherCandiddates data={candidateList} />;
//       case "reports":
//         return (
//           <Report
//             seekerReport={jobSeekerReport}
//             employerReport={jobEmployerReport}
//           />
//         );
//       case "interviews":
//         return <InterviewsReport data={interviewData} />;
//       default:
//         return (
//           <DashboardSummary
//             allApplication={allApplication}
//             allEmployers={allEmployers}
//             allJobSeeker={allJobSeeker}
//             allJobs={allJobs}
//             allNotification={allNotification}
//           />
//         );
//     }
//   };

//   return (
//     <div className="w-screen h-screen sm:overflow-hidden overflow-scroll bg-gray-900 text-white">
//       <div className="mx-4 md:mx-24">
//         <Header lightMode={true} />
//         <div className="w-full py-4">
//           <div className="flex items-center relative py-1 px-2 justify-start border-2 border-gray-700 bg-gray-800 rounded-md w-full md:w-1/2 mx-auto shadow-sm">
//             <BiSearch className="text-gray-400" />
//             <input
//               className="w-full bg-transparent px-2 text-gray-200 outline-none"
//               type="text"
//               placeholder="Search..."
//             />
//           </div>
//         </div>

//         <div className="w-full border-t-2 border-gray-700 h-auto mt-5 flex flex-col md:flex-row items-start justify-center bg-gray-800 shadow-lg rounded-lg">
//           <div className="w-full md:w-1/4 h-auto md:h-[480px] overflow-y-scroll border-r-2 border-gray-700 p-4 bg-gray-900">
//             <div
//               onClick={() => setSelection("home")}
//               className={`cursor-pointer ${
//                 selection === "home" ? "bg-gray-600" : ""
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <GrPieChart className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Dashboard</span>
//             </div>
//             <div
//               onClick={() => setSelection("profile")}
//               className={`cursor-pointer ${
//                 selection === "profile" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <CgProfile className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Profile</span>
//             </div>
//             <div
//               onClick={() => setSelection("jobSeeker")}
//               className={`cursor-pointer ${
//                 selection === "jobSeeker" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <GrGroup className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Job Seekers</span>
//             </div>
//             <div
//               onClick={() => setSelection("jobEmployer")}
//               className={`cursor-pointer ${
//                 selection === "jobEmployer" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <GrGroup className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Job Employers</span>
//             </div>
//             <div
//               onClick={() => setSelection("jobs")}
//               className={`cursor-pointer ${
//                 selection === "jobs" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <MdWork className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Jobs</span>
//             </div>
//             <div
//               onClick={() => setSelection("benefits")}
//               className={`cursor-pointer ${
//                 selection === "benefits" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <BsEnvelopeAtFill className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Benefit Request</span>
//             </div>
//             <div
//               onClick={() => setSelection("salary")}
//               className={`cursor-pointer ${
//                 selection === "salary" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <FaMoneyBillTransfer className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Salary Payments</span>
//             </div>
//             <div
//               onClick={() => setSelection("reports")}
//               className={`cursor-pointer ${
//                 selection === "reports" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <MdReport className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Reports</span>
//             </div>
//             <div
//               onClick={() => setSelection("interviews")}
//               className={`cursor-pointer ${
//                 selection === "interviews" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <CgScreen className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Interviews</span>
//             </div>
//             <div
//               onClick={() => setSelection("otherCandidates")}
//               className={`cursor-pointer ${
//                 selection === "otherCandidates" && "bg-gray-600"
//               } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
//             >
//               <BsPeople className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Add others</span>
//             </div>
//             <Link
//               to="/signin"
//               className="cursor-pointer flex items-center mb-4 p-2 hover:bg-gray-700 rounded"
//             >
//               <BiExit className="mr-2 text-gray-400" />
//               <span className="text-gray-200">Sign out</span>
//             </Link>
//           </div>

//           <div className="w-full md:w-3/4 h-auto md:h-[480px] overflow-scroll bg-gray-900 p-6">
//             {renderView()}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;





import React, { useEffect, useState } from "react";
import { BiSearch, BiExit, BiMenu } from "react-icons/bi";
import { GrPieChart, GrGroup } from "react-icons/gr";
import { CgProfile, CgScreen } from "react-icons/cg";
import { MdReport, MdWork } from "react-icons/md";
import Header from "../../component/Header";
import { BsEnvelopeAtFill, BsMenuUp, BsPeople } from "react-icons/bs";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import DashboardSummary from "../../component/DashboardComponents/DashboardSummary";
import Profile from "../../component/DashboardComponents/Profile";
import JobSeeker from "../../component/DashboardComponents/jobSeeker";
import JobEmployer from "../../component/DashboardComponents/JobEmployer";
import JobsInfo from "../../component/DashboardComponents/Jobs";
import BenefitReguests from "../../component/DashboardComponents/BenefitReguests";
import SalaryPayment from "../../component/DashboardComponents/SalaryPayment";
import Report from "../../component/DashboardComponents/Report";
import InterviewsReport from "../../component/DashboardComponents/Interview";
import OtherCandiddates from "../../component/DashboardComponents/OtherCandiddates";
import { setCandidateList } from "../../redux/candidateList/candidateListSlice";

ChartJS.register(ArcElement, Tooltip, Legend);

const getAllJobURL = `${process.env.REACT_APP_API_URL}job/allJob`;
const getAllNotificationURL = `${process.env.REACT_APP_API_URL}notification/getAllNotification`;
const getAllApplications = `${process.env.REACT_APP_API_URL}application/allApplication`;
const getAllEmployer = `${process.env.REACT_APP_API_URL}jobrecruiter/allJobEmployer`;
const getAllJobSeeker = `${process.env.REACT_APP_API_URL}jobSeeker/allJobSeeker`;
const getAllInterview = `${process.env.REACT_APP_API_URL}interview/getAllInterview`;
const getJobSeekerReport = `${process.env.REACT_APP_API_URL}employeeReport/getAllEmployeeReport`;
const getEmployerReport = `${process.env.REACT_APP_API_URL}employerReport/getAllEmployerReport`;
const getAllCandidates = `${process.env.REACT_APP_API_URL}otherCandidate/getAllCandidate`;

const Dashboard = () => {
  const [allJobs, setAllJobs] = useState([]);
  const [allNotification, setAllNotification] = useState([]);
  const [allApplication, setAllApplication] = useState([]);
  const [allEmployers, setAllEmployers] = useState([]);
  const [allJobSeeker, setAllJobSeeker] = useState([]);
  const [selection, setSelection] = useState("home");
  const [interviewData, setInterviewData] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const candidateList = useSelector(
    (state) => state.candidateList.candidateList
  );
  const [jobSeekerReport, setJobSeekerReport] = useState([]);
  const [jobEmployerReport, setJobEmployerReport] = useState([]);
  const [allCandidates, setAllCandidates] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const getData = async () => {
      const appData = await Promise.all(
        [
          getAllJobURL,
          getAllNotificationURL,
          getAllApplications,
          getAllEmployer,
          getAllJobSeeker,
          getAllInterview,
          getJobSeekerReport,
          getEmployerReport,
          getAllCandidates,
        ].map(async (eachURL) => {
          const data = await axios.get(eachURL);
          return data.data;
        })
      );
      setAllJobs(appData[0]);
      setAllNotification(appData[1]);
      setAllApplication(appData[2]);
      setAllEmployers(appData[3]);
      setAllJobSeeker(appData[4]);
      setInterviewData(appData[5]);
      setJobSeekerReport(appData[6]);
      setJobEmployerReport(appData[7]);
    };
    getData();
  }, []);

  useEffect(() => {
    const fetchAllCandidate = () => {
      axios
        .get(getAllCandidates)
        .then((response) => {
          dispatch(setCandidateList(response.data));
          console.log("result", response.data);
          setAllCandidates();
        })
        .catch((error) => {
          console.log(error);
        });
    };

    fetchAllCandidate();
  }, []);

  const renderView = () => {
    const pieChartData = (labels, data) => ({
      labels,
      datasets: [
        {
          data,
          backgroundColor: ['#f97316', '#d1d5db', '#ef4444', '#22c55e'],
          borderColor: '#374151',
          borderWidth: 1,
        },
      ],
    });

    switch (selection) {
      case "profile":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Profile Summary</h2>
              <Profile data={currentUser} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Activity</h2>
              <Pie data={pieChartData(['Logins', 'Updates'], [currentUser?.lastLogin ? 1 : 0, currentUser?.updates || 0])} />
            </div>
          </div>
        );
      case "jobSeeker":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Job Seekers</h2>
              <JobSeeker data={allJobSeeker} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Status Distribution</h2>
              <Pie data={pieChartData(['Active', 'Blacklisted', 'Verified'], [
                allJobSeeker.filter(j => !j.isBlacklisted && !j.isVerified).length,
                allJobSeeker.filter(j => j.isBlacklisted).length,
                allJobSeeker.filter(j => j.isVerified).length,
              ])} />
            </div>
          </div>
        );
      case "jobEmployer":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Job Employers</h2>
              <JobEmployer data={allEmployers} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Employer Distribution</h2>
              <Pie data={pieChartData(['Active', 'Inactive'], [
                allEmployers.filter(e => e.status === 'active').length,
                allEmployers.filter(e => e.status !== 'active').length,
              ])} />
            </div>
          </div>
        );
      case "jobs":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Jobs</h2>
              <JobsInfo data={allJobs} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Job Categories</h2>
              <Pie data={pieChartData(['Open', 'Closed', 'Pending'], [
                allJobs.filter(j => j.status === 'open').length,
                allJobs.filter(j => j.status === 'closed').length,
                allJobs.filter(j => j.status === 'pending').length,
              ])} />
            </div>
          </div>
        );
      case "benefits":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Benefit Requests</h2>
              <BenefitReguests data={[1, 2]} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Request Status</h2>
              <Pie data={pieChartData(['Approved', 'Pending', 'Rejected'], [1, 1, 0])} />
            </div>
          </div>
        );
      case "salary":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Salary Payments</h2>
              <SalaryPayment />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Payment Status</h2>
              <Pie data={pieChartData(['Paid', 'Pending'], [5, 2])} />
            </div>
          </div>
        );
      case "otherCandidates":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Other Candidates</h2>
              <OtherCandiddates data={candidateList} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Candidate Status</h2>
              <Pie data={pieChartData(['Active', 'Inactive'], [candidateList?.length || 0, 0])} />
            </div>
          </div>
        );
      case "reports":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Reports</h2>
              <Report seekerReport={jobSeekerReport} employerReport={jobEmployerReport} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Report Types</h2>
              <Pie data={pieChartData(['Seeker', 'Employer'], [jobSeekerReport.length, jobEmployerReport.length])} />
            </div>
          </div>
        );
      case "interviews":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Interviews</h2>
              <InterviewsReport data={interviewData} />
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Interview Status</h2>
              <Pie data={pieChartData(['Scheduled', 'Completed'], [
                interviewData.filter(i => !i.completed).length,
                interviewData.filter(i => i.completed).length,
              ])} />
            </div>
          </div>
        );
      default:
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center">
              <GrGroup className="text-orange-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold">Job Seekers</h3>
                <p className="text-gray-400">{allJobSeeker.length}</p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center">
              <GrGroup className="text-orange-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold">Employers</h3>
                <p className="text-gray-400">{allEmployers.length}</p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center">
              <MdWork className="text-orange-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold">Jobs</h3>
                <p className="text-gray-400">{allJobs.length}</p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center">
              <BsEnvelopeAtFill className="text-orange-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold">Notifications</h3>
                <p className="text-gray-400">{allNotification.length}</p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center">
              <MdReport className="text-orange-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold">Applications</h3>
                <p className="text-gray-400">{allApplication.length}</p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg flex items-center">
              <CgScreen className="text-orange-500 mr-4" />
              <div>
                <h3 className="text-lg font-semibold">Interviews</h3>
                <p className="text-gray-400">{interviewData.length}</p>
              </div>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-lg col-span-2 md:col-span-1">
              <h2 className="text-xl font-semibold text-orange-500 mb-4">Overview</h2>
              <Pie data={pieChartData(['Seekers', 'Employers', 'Jobs'], [
                allJobSeeker.length,
                allEmployers.length,
                allJobs.length,
              ])} />
            </div>
          </div>
        );
    }
  };

  return (
    <div className="w-screen h-screen sm:overflow-hidden overflow-scroll bg-gray-900 text-white">
      <div className="mx-4 md:mx-24">
        <Header lightMode={true} />
        <div className="w-full py-4">
          <div className="flex items-center relative py-1 px-2 justify-start border-2 border-gray-700 bg-gray-800 rounded-md w-full md:w-1/2 mx-auto shadow-sm">
            <BiSearch className="text-gray-400" />
            <input
              className="w-full bg-transparent px-2 text-gray-200 outline-none"
              type="text"
              placeholder="Search..."
            />
          </div>
        </div>

        <div className="w-full border-t-2 border-gray-700 h-auto mt-5 flex flex-col md:flex-row items-start justify-center bg-gray-800 shadow-lg rounded-lg">
          <div className="w-full md:w-1/4 h-auto md:h-[480px] overflow-y-scroll border-r-2 border-gray-700 p-4 bg-gray-900">
            <div
              onClick={() => setSelection("home")}
              className={`cursor-pointer ${
                selection === "home" ? "bg-gray-600" : ""
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <GrPieChart className="mr-2 text-gray-400" />
              <span className="text-gray-200">Dashboard</span>
            </div>
            <div
              onClick={() => setSelection("profile")}
              className={`cursor-pointer ${
                selection === "profile" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <CgProfile className="mr-2 text-gray-400" />
              <span className="text-gray-200">Profile</span>
            </div>
            <div
              onClick={() => setSelection("jobSeeker")}
              className={`cursor-pointer ${
                selection === "jobSeeker" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <GrGroup className="mr-2 text-gray-400" />
              <span className="text-gray-200">Job Seekers</span>
            </div>
            <div
              onClick={() => setSelection("jobEmployer")}
              className={`cursor-pointer ${
                selection === "jobEmployer" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <GrGroup className="mr-2 text-gray-400" />
              <span className="text-gray-200">Job Employers</span>
            </div>
            <div
              onClick={() => setSelection("jobs")}
              className={`cursor-pointer ${
                selection === "jobs" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <MdWork className="mr-2 text-gray-400" />
              <span className="text-gray-200">Jobs</span>
            </div>
            <div
              onClick={() => setSelection("benefits")}
              className={`cursor-pointer ${
                selection === "benefits" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <BsEnvelopeAtFill className="mr-2 text-gray-400" />
              <span className="text-gray-200">Benefit Request</span>
            </div>
            <div
              onClick={() => setSelection("salary")}
              className={`cursor-pointer ${
                selection === "salary" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <FaMoneyBillTransfer className="mr-2 text-gray-400" />
              <span className="text-gray-200">Salary Payments</span>
            </div>
            <div
              onClick={() => setSelection("reports")}
              className={`cursor-pointer ${
                selection === "reports" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <MdReport className="mr-2 text-gray-400" />
              <span className="text-gray-200">Reports</span>
            </div>
            <div
              onClick={() => setSelection("interviews")}
              className={`cursor-pointer ${
                selection === "interviews" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <CgScreen className="mr-2 text-gray-400" />
              <span className="text-gray-200">Interviews</span>
            </div>
            <div
              onClick={() => setSelection("otherCandidates")}
              className={`cursor-pointer ${
                selection === "otherCandidates" && "bg-gray-600"
              } flex items-center mb-4 p-2 hover:bg-gray-700 rounded`}
            >
              <BsPeople className="mr-2 text-gray-400" />
              <span className="text-gray-200">Add others</span>
            </div>
            <Link
              to="/signin"
              className="cursor-pointer flex items-center mb-4 p-2 hover:bg-gray-700 rounded"
            >
              <BiExit className="mr-2 text-gray-400" />
              <span className="text-gray-200">Sign out</span>
            </Link>
          </div>

          <div className="w-full md:w-3/4 h-auto md:h-[480px] overflow-scroll bg-gray-900 p-6">
            {renderView()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;